// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ar","poster":"e_br","player":"e_cr","play":"e_dr","playBadge":"e_er","playIcon":"e_fr","loading":"e_gr","spin":"e_hr"};